import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fdf4a6f8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fdf4a6f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf4a6f8",
  null
  
)

/* custom blocks */
import block0 from "./locales/index.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Frandyhoulahan%2Fprojects%2F%40scbd%2Fecosystem%2Fpackages%2Fpage-header%2Fsrc%2Findex.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports